const I = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTEwIDJhOCA4IDAgMCAxIDYuMzIgMTIuOTA1bDUuMzg3IDUuMzg4LTEuNDE0IDEuNDE0LTUuMzg4LTUuMzg2QTggOCAwIDEgMSAxMCAyem0wIDJhNiA2IDAgMSAwIDAgMTIgNiA2IDAgMCAwIDAtMTJ6IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4K";
export {
  I as default
};
//# sourceMappingURL=search-3bcdf92d.mjs.map
